import {
  Stack,
  Box,
  Typography,
  IconButton,
  Autocomplete,
  TextField,
} from "@mui/material";
import React, { useState, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../../app/hooks";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { editVariance } from "../../../../../../services/varianceService/model/varianceRequest/VarianceRequestSlice";
import { useCenterListQuery } from "../../../../../../services/orgService/org-api";

function CenterSelection(props: { canEdit: boolean }) {
  const dispatch = useAppDispatch();
  const incident = useAppSelector(
    (state) => state.varianceRequest.varianceRequest
  );

  const { data: centers } = useCenterListQuery();

  const activeCenters = useMemo(() => {
    if (!centers) return [];
    return centers
      .filter((c) => !c.isInactive)
      .slice()
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [centers]);

  const currentCenterName = useMemo(() => {
    if (!centers || !incident.center) return incident.center;
    const found = centers.find((c) => c.code === incident.center);
    return found ? found.name : incident.center;
  }, [centers, incident.center]);

  const [editing, setEditing] = useState(false);

  return (
    <React.Fragment>
      <Box>
        {!editing && (
          <Stack direction="row">
            <Typography variant="h6" className="psn-green">
              Center: &nbsp;
            </Typography>
            <Typography variant="h6" className="psn-green">
              {currentCenterName}
            </Typography>
            <IconButton
              disabled={!props.canEdit}
              size="small"
              onClick={() => setEditing(true)}
            >
              <ModeEditOutlinedIcon fontSize="small" />
            </IconButton>
          </Stack>
        )}
        {editing && (
          <Stack direction="row">
            <Autocomplete
              disabled={!props.canEdit}
              sx={{ width: 300 }}
              value={activeCenters.find((c) => c.code === incident.center) || null}
              onChange={(_event, value) => {
                if (value) {
                  dispatch(editVariance({ name: "center", value: value.code }));
                }
              }}
              options={activeCenters}
              getOptionLabel={(option) => option.name}
              isOptionEqualToValue={(option, value) => option.code === value.code}
              renderInput={(params) => (
                <TextField {...params} label="Center / Facility" />
              )}
            />
            <IconButton
              disabled={!props.canEdit}
              size="small"
              onClick={() => setEditing(false)}
            >
              <CheckCircleOutlineOutlinedIcon fontSize="small" />
            </IconButton>
          </Stack>
        )}
      </Box>
    </React.Fragment>
  );
}

export { CenterSelection };
